import React, { useEffect } from 'react';
import { history } from 'ice';
import store from '@/store';
import Requests from '@/services/request';
import { goToDuiba, goToLingyang } from '@/utils/index';
import { getMenuConfig } from '@/menuConfig';
import { getQueryStringArgs } from '@/utils/url-parse';
import qs from 'query-string';
// import appCenter from '@alife/superapp-app-center';

export const jumpToPage = (spaceInfo, userState) => {
  const { isDuibaUser } = userState?.currentUser || {};
  const _spaceId = spaceInfo?.spaceId || '';

  // 非兑吧 && 当前用户没有可用空间时: 跳转到waiting页面
  if (!isDuibaUser && !spaceInfo?.spaceId) {
    history?.push('/waiting');
    return;
  }

  const menuList = getMenuConfig(
    Object.assign({}, spaceInfo || {}, { isUpdate: true }),
    userState.currentUser,
  )?.[0];

  const path = menuList?.children?.[0]?.path || menuList?.path;
  if (!path) {
    return;
  }

  if (path.includes('/duiba')) {
    // 兑吧菜单
    goToDuiba(_spaceId);
    return;
  }

  if (path.startsWith('/ly_analyse') || path.startsWith('/ly_track')) {
    goToLingyang(spaceInfo.spaceId, path);
    return;
  }


  history?.push(`${path}?spaceId=${_spaceId}`, {
    spaceId: _spaceId,
  });
};

const Home: React.FC = () => {
  const [userState] = store.useModel('user');
  const [, spaceRoleDispatcher] = store.useModel('spaceRole');
  const { spaceId: urlSpaceId } = getQueryStringArgs();

  useEffect(() => {
    Requests.get('/rest/intercnn/space/query', {
      status: 'ACTIVE',
      pageSize: 1000,
    }).then((data) => {
      const list = (data?.list || [])?.map((item) => ({
        ...item,
        roleList: item?.role?.split(',') || [],
        value: item?.spaceId,
        label: item?.name,
      }));
      const spaceInfo = list.find((i) => i.spaceId === urlSpaceId) || list[0] || {};
      spaceRoleDispatcher.updateCharacterInfo(spaceInfo);
      jumpToPage(spaceInfo, userState);
    });
  }, []);

  return <></>;
};

export default Home;
